import { MdOutlineElectricBolt } from "react-icons/md";
import { FaCheck } from "react-icons/fa6";
import { IoMdList } from "react-icons/io";
import { HiMiniBellAlert } from "react-icons/hi2";


import {motion} from 'motion/react'

import './Totalizadores.css'
import { useAuth } from "../../../context/AuthContext";
export default function Totalizadores({totalizers, newTickets}){

    const {user} = useAuth()
    const nome = user?.name.split(" ")

    return (
        <div className="totalizadores">
            <motion.div 
                initial="initial"
                whileHover="hover"
                className="emAberto card"
            >
                <motion.div
                     variants={{
                        initial:{rotate: 0},
                        hover: {
                            rotate: [0, -10, 10, -8, 8, 0]
                        }
                    }}
                    className="flex"
                >
                    <MdOutlineElectricBolt color="var(--cinza)" className="iconCard"/>
                 </motion.div>
                 <div>
                    <p>
                        Abertos:
                    </p>
                    <h1 className='numero'>{totalizers && totalizers.open}</h1>
                 </div>
            </motion.div>

            <motion.div 
                initial="initial"
                whileHover="hover"
                className="encerrados card"
            >

                <motion.div
                     variants={{
                        initial:{rotate: 0},
                        hover: {
                            rotate: [0, -10, 10, -8, 8, 0]
                        }
                    }}
                    className="flex"
                >

                    <FaCheck color="var(--cinza)" className="iconCard"/>
                </motion.div>

                 <div>
                    <p>
                        Encerrados:
                    </p>
                    <h1 className='numero'>{totalizers && totalizers.closed}</h1>
                 </div>
            </motion.div>

            <motion.div 
                initial="initial"
                whileHover="hover"
                className="total card"
            >
                <motion.div
                     variants={{
                        initial:{rotate: 0},
                        hover: {
                            rotate: [0, -10, 10, -8, 8, 0]
                        }
                    }}
                    className="flex">

                    <IoMdList color="var(--cinza)" className="iconCard"/>

                </motion.div>
                <div>
                    <p>
                        Total:
                    </p>
                    <h1 className='numero'>{totalizers && totalizers.total}</h1>
                </div>
            </motion.div>

            {newTickets > 0 &&   <motion.div
                initial="initial"
                whileHover="hover"

                animate={{
                    opacity:1,
                    scale:1.0
                }}
                transition={{
                    type: "spring",
                    delay:0.8,
                    stiffness: 300,
                    damping: 20,
                    duration: 0.8,
                    ease: "easeOut"
                }}
                variants={{
                   initial:{opacity: 0, scale: 0.2 }
                }}
                
                className="notification flex"
            >
                <motion.div
                    variants={{
                        initial:{rotate: 0},
                    }}
                    initial={{rotate: 0, scale: 1.0}}
                    animate={{ rotate: [-10, 0, -10, 0, -10,0, -10, 0], scale:[1.02, 1.0]}}
                    
                    transition={{
                        delay:1.02,
                        ease:'easeInOut',
                        duration: 0.8
                     }}
                     
                     className="flex"
                >
                    <HiMiniBellAlert className="iconCard" color="var(--vermelho)" />
                </motion.div>
                <div className="notificationText">
                    <h2>Novos chamados!</h2>
                    <h3><span className="numero">{newTickets}</span> novos desafios aguardam você</h3>
                </div>
            </motion.div>}
        </div>
    )
}